import { createContext, type ReactNode, useContext } from "react";
import type { Key } from "react-aria";

import type { PanelOrientation, PanelPosition } from "../settings.ts";

// Context
export interface PanelGroupContextValue {
  orientation: PanelOrientation;
  fixedPanel: PanelPosition;
  isOpen: boolean;
  currentSize: number | undefined | null;
  max: number;
  maxSize: number;
  minSize: number;
  isResizing: boolean;
  isContinuous: boolean;
  closedSize: number;
  noResize: boolean;
  // Tab context
  activeTabId: Key | null;
  setActiveTabId: (tabId: Key) => void;
  tabsActions?: ReactNode;
  openOnTabPress?: boolean;
  openPanel: () => void;
  closePanel: () => void;
  togglePanel: () => void;
}

export const PanelGroupContext = createContext<PanelGroupContextValue | null>(null);

export const useResizableTabPanelsContext = () => {
  const context = useContext(PanelGroupContext);
  if (!context) {
    throw new Error("Panel components must be used within PanelGroup");
  }
  return context;
};
